/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MeetingMinuteDetailsAliases {
  ACTION_ACCEPT = 'action-accept',
  ACTION_REFUSE = 'action-refuse',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ATTACHMENTS = 'deck-attachments',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FETCH_MEETING_MINUTE_DETAILS = 'fetch-meeting-minute-details',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_MEETING_MINUTE_DATE = 'field-meeting-minute-date',
  FIELD_STATUS = 'field-status',
  FORM_0 = 'form-0',
  FORM_REFUSE = 'form-refuse',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  IMAGE_0 = 'image-0',
  LAYOUT_0 = 'layout-0',
  MODAL_REFUSE = 'modal-refuse',
  PANEL_0 = 'panel-0',
  PANEL_ATTACHMENTS = 'panel-attachments',
  PANEL_REFUSE = 'panel-refuse',
  PANEL_VALUES = 'panel-values',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_AREA_0 = 'text-area-0',
}
export { MeetingMinuteDetailsAliases };
